export default (callback, searchValue, client = 0) => {
    document.activeElement?.blur();
    app.modules.use('app.contragents.add').then(() => {
        app.contragents.add((result) => {
            callback(result);
        }, searchValue, client);
    });
};
